import { useState } from 'react'
import { Modal, Field, Input, Select, Textarea } from '../components/ui'
import { ITEM_STATUSES } from '../lib/constants'
import { createItem, updateItem } from '../lib/supabase'
import { useSettings } from '../lib/settings'

export default function ItemForm({ initial = {}, roomId, homeId, rooms = [], onSave, onClose }) {
  const { activeCategories } = useSettings()
  const [form, setForm] = useState({
    name: '', type: '', brand: '', details: '', model_number: '',
    color_finish: '', dimensions: '', cost: '', date_purchased: '',
    purchase_url: '', warranty_url: '', image_url: '', status: 'Considering',
    notes: '',
    ...initial,
    cost: initial.cost != null ? String(initial.cost) : '',
    room_id: roomId || initial.room_id || '',
    home_id: homeId || initial.home_id || '',
  })
  const [saving, setSaving] = useState(false)
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const handleSave = async () => {
    if (!form.name.trim()) return
    setSaving(true)
    const payload = {
      ...form,
      cost: form.cost ? parseFloat(form.cost) : null,
      date_purchased: form.date_purchased || null,
      room_id: form.room_id || roomId,
      home_id: homeId,
    }
    console.log('Saving item with payload:', payload)
    try {
      initial.id ? await updateItem(initial.id, payload) : await createItem(payload)
      await onSave()
    } catch (err) {
      console.error('Error saving item:', err)
      alert(`Error saving item: ${err.message}`)
    } finally { setSaving(false) }
  }

  const showRoomPicker = !roomId && rooms.length > 0

  return (
    <Modal title={initial.id ? 'Edit Item' : 'Add Item'} onClose={onClose} size="lg"
      footer={<><button className="btn btn-ghost" onClick={onClose}>Cancel</button><button className="btn btn-primary" onClick={handleSave} disabled={saving || !form.name.trim()}>{saving ? 'Saving…' : 'Save Item'}</button></>}>
      <Field label="Item Name *">
        <Input placeholder='e.g. 36" Gas Range' value={form.name} onChange={e => set('name', e.target.value)} />
      </Field>
      <div className="form-row">
        <Field label="Type">
          <Select value={form.type} onChange={e => set('type', e.target.value)}>
            <option value="">Select type…</option>
            {activeCategories.map(c => <option key={c.key} value={c.key}>{c.emoji} {c.key}</option>)}
          </Select>
        </Field>
        <Field label="Status">
          <Select value={form.status} onChange={e => set('status', e.target.value)}>
            {ITEM_STATUSES.map(s => <option key={s}>{s}</option>)}
          </Select>
        </Field>
      </div>
      {showRoomPicker && (
        <Field label="Space">
          <Select value={form.room_id} onChange={e => set('room_id', e.target.value)}>
            <option value="">Select space…</option>
            {rooms.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
          </Select>
        </Field>
      )}
      <div className="form-row">
        <Field label="Brand"><Input placeholder="e.g. Bertazzoni" value={form.brand} onChange={e => set('brand', e.target.value)} /></Field>
        <Field label="Cost"><Input type="number" placeholder="0.00" value={form.cost} onChange={e => set('cost', e.target.value)} /></Field>
      </div>
      <Field label="Details" hint="Model description, spec notes, etc.">
        <Input placeholder="e.g. Freestanding Gas Range, Stainless" value={form.details} onChange={e => set('details', e.target.value)} />
      </Field>
      <div className="form-row">
        <Field label="Model / Item #"><Input placeholder="e.g. MAST366GASNE" value={form.model_number} onChange={e => set('model_number', e.target.value)} /></Field>
        <Field label="Color / Finish"><Input placeholder="e.g. Stainless" value={form.color_finish} onChange={e => set('color_finish', e.target.value)} /></Field>
      </div>
      <Field label="Dimensions"><Input placeholder='e.g. 36"W × 36"H' value={form.dimensions} onChange={e => set('dimensions', e.target.value)} /></Field>
      <Field label="Date Purchased"><Input type="date" value={form.date_purchased} onChange={e => set('date_purchased', e.target.value)} /></Field>
      <Field label="Purchase URL"><Input placeholder="https://…" value={form.purchase_url} onChange={e => set('purchase_url', e.target.value)} /></Field>
      <Field label="Warranty URL / Doc" hint="Link or Google Drive URL"><Input placeholder="https://…" value={form.warranty_url} onChange={e => set('warranty_url', e.target.value)} /></Field>
      <Field label="Image URL"><Input placeholder="https://…" value={form.image_url} onChange={e => set('image_url', e.target.value)} /></Field>
      <Field label="Notes"><Textarea placeholder="Additional notes…" value={form.notes} onChange={e => set('notes', e.target.value)} /></Field>
    </Modal>
  )
}
